import React, { useState } from 'react';
import asphalt from '../../../assets/ReynoldsburgPage/Residential Roof/Residential_Shingle_Roofing_Reynoldsburg_Ohio_Ultimatesroofing.jpg';
import metal from '../../../assets/ReynoldsburgPage/Residential Roof/residential_Metal_Roofing_ Reynoldsburg_Ohio_Ultiamtesroofing.jpg';
import tile from '../../../assets/ColumbusPage/Roofing Materials/Tile_Roofing_Columbus_Ohio_Ultimatesroofing.jpg'; // fallback
import flat from '../../../assets/ReynoldsburgPage/Commercial Roof/Commercial_TPO_Roofing_Reynoldsburg_Ohio_Ultimatesroofing.webp'; // local flat roof representation

const portfolioData = [
  {
    id: "asphalt",
    title: "Asphalt",
    tag: "Residential Favorite",
    heading: "Asphalt Shingles",
    description: "Cost-effective shingles offering durability, versatility, and reliable protection for residential properties.",
    image: asphalt
  },
  {
    id: "metal",
    title: "Metal",
    tag: "Long-Lasting",
    heading: "Metal Roofing",
    description: "Strong metal roofing provides longevity, energy efficiency, and excellent weather resistance.",
    image: metal
  },
  {
    id: "tile",
    title: "Tile",
    tag: "Premium Style",
    heading: "Tile Roofing",
    description: "Tile roofing offers durability, unique style, and long-lasting performance in harsh climates.",
    image: tile 
  },
  {
    id: "flat",
    title: "Flat",
    tag: "Commercial Grade",
    heading: "Flat Roofing Materials",
    description: "High-quality flat roofing materials ensure durability, flexibility, and reliable waterproof protection.",
    image: flat
  }
];

const PortfolioSection = () => {
  const [activeTab, setActiveTab] = useState(portfolioData[0].id);
  const activeIndex = portfolioData.findIndex((item) => item.id === activeTab);
  const activeContent = portfolioData[activeIndex];

  const handlePrev = () => {
    const nextIndex = (activeIndex - 1 + portfolioData.length) % portfolioData.length;
    setActiveTab(portfolioData[nextIndex].id);
  };

  const handleNext = () => {
    const nextIndex = (activeIndex + 1) % portfolioData.length;
    setActiveTab(portfolioData[nextIndex].id);
  };

  return (
    <section className="cs-section portfolio-section">
      <style>{`
        

        .portfolio-section {
          background-color: #b22335;
         
          padding: 30px 10px; /* desktop */
        }

        /* mobile + tablet padding */
        @media (max-width: 1024px) {
          .portfolio-section {
            padding: 10px 10px;
          }
        }

        .ps-main-heading {
          font-family: hauora-medium, sans-serif;
          letter-spacing: -1px;
          color: #ffffff;
          margin-bottom: 16px;
        }

        .ps-navy { color: #3D3B6D; }

        .ps-lead {
          font-family: hauora-medium, sans-serif;
          font-size: 19px;
          line-height: 1.9;
          color: rgba(255, 255, 255, 0.9);
          max-width: 700px;
        }

        .ps-nav-bg {
          background-color: #3D3B6D;
          border-radius: 12px 12px 0 0;
          overflow: hidden;
        }

        .ps-tab-btn {
          font-family: hauora-medium, sans-serif;
          font-size: calc(1rem + 0.55vw);
          border: none;
          background: none;
          color: rgba(255, 255, 255, 0.5);
          padding: 20px 16px;
          width: 100%;
          transition: all 0.3s ease;
          cursor: pointer;
        }

        .ps-tab-btn:hover {
          background-color: rgba(255, 255, 255, 0.1);
          color: #ffffff;
        }

        .ps-tab-btn.ps-active {
          background-color: #f8f9fa;
          color: #b22335;
        }

        .ps-content-body {
          background-color: #f8f9fa;
          padding: 48px;
          border-radius: 0 0 12px 12px;
          position: relative;
        }

        .ps-tag {
          font-size: 15px;
          font-weight: 700;
          color: #b22335;
          letter-spacing: 1.5px;
        }

        .ps-card-heading {
          font-size: calc(1.5rem + 1.8vw);
          font-weight: 800;
          color: #3D3B6D;
          margin: 12px 0 16px;
        }

        .ps-card-desc {
          font-size: 19px;
          line-height: 1.9;
          color: #4d5663;
        }

        .ps-img-wrap {
          padding: 8px;
          background: #ffffff;
          border-radius: 8px;
          box-shadow: 0 4px 15px rgba(0,0,0,0.08);
        }

        .ps-img-wrap img {
          width: 100%;
          border-radius: 6px;
          display: block;
        }

        .ps-nav-arrow {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 45px;
          height: 45px;
          border-radius: 50%;
          border: none;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 10;
          cursor: pointer;
          background: none;
          padding: 0;
        }

        .ps-nav-arrow i {
          font-weight: 100;
          font-size: 1.5rem;
        }

        .ps-prev {
          left: -22px;
          color: #3D3B6D;
        }

        .ps-next {
          right: -22px;
          color: #3D3B6D;
        }

        .ps-prev:hover,
        .ps-next:hover {
          color: #b22335;
        }

        @media (max-width: 576px) {
          .ps-nav-arrow {
            display: none;
          }
        }
      `}</style>

      <div className="container">
        <div>
          <h2 className="cs-title ps-main-heading">
            Type of Roofing <span className="text-white">Materials We Use</span>
          </h2>
          <p className="cs-desc ps-lead">
            We use only the highest quality materials to ensure your roof stands the test of time.
          </p>
        </div>

        <div className="cs-content shadow-lg">
          <ul className="nav nav-justified ps-nav-bg border-0 m-0 p-0">
            {portfolioData.map((tab) => (
              <li className="nav-item" key={tab.id}>
                <button
                  className={`ps-tab-btn ${activeTab === tab.id ? 'ps-active' : ''}`}
                  onClick={() => setActiveTab(tab.id)}
                >
                  {tab.title}
                </button>
              </li>
            ))}
          </ul>

          <div className="ps-content-body">
            <div className="row align-items-center g-5">
              <div className="col-lg-6 order-2 order-lg-1">
                <span className="ps-tag">{activeContent.tag}</span>
                <h3 className="ps-card-heading">{activeContent.heading}</h3>
                <p className="ps-card-desc">{activeContent.description}</p>
              </div>

              <div className="col-lg-6 order-1 order-lg-2">
                <div className="ps-img-wrap">
                  <img src={activeContent.image} alt={activeContent.heading} />
                </div>
              </div>
            </div>

            <div className="d-none d-md-block">
              <button className="ps-nav-arrow ps-prev" onClick={handlePrev}>
                <i className="bi bi-chevron-left"></i>
              </button>
              <button className="ps-nav-arrow ps-next" onClick={handleNext}>
                <i className="bi bi-chevron-right"></i>
              </button>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default PortfolioSection;